import React, { useMemo } from 'react';

import DataTable from 'Common/Table/DataTable';

const questionSchema = [
    { field: "question", label: "Question", className: "th-td-50" },
    { field: "answer", label: "Answer", className: "th-td-50" }
];

function ExpansionContent({ row }) {
    const questions = useMemo(() => {
        const result = [];
        if (row.additionalInfo) {
            for (const question in row.additionalInfo) {
                result.push({ question, answer: row.additionalInfo[question] });
            }
        }
        return result;
    }, [row]);

    return (
        <DataTable
            dataSource={questions}
            keyField="question"
            schema={questionSchema}
            variant="inner"
        />
    );
}

export default React.memo(ExpansionContent);
